import ClickAwayListener from "./ClickAwayListener.ts";

export default ClickAwayListener;